<template>
<div>
  <CriteriaNetworkInfo />
  <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm" />
    <div id="criteria-bar" :class="criteriaClass">
        <CriteriaType />
        <CriteriaName />
        <CriteriaToHelpMeWith v-if="showToHelpMeWith"/>
        <CriteriaNear />
        <CriteriaSearchButton id="button-container"/>
        <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs" />
    </div>
</div>
</template>

<script setup>

    const { criteriaContext } = useFCPModel()
    const type = computed(() => criteriaContext.value.type)
    const showToHelpMeWith = computed(() => type.value != 'urgent' &&
          type.value != 'hospital:1' && type.value != 'hospital:2' && type.value != 'hospital:3')
    const criteriaClass = computed(() => (showToHelpMeWith.value ? 'with-helpme' : 'without-helpme'))

</script>

<style scoped lang="scss">
@use '../../assets/scss/breakpoints' as *;
@use '../../assets/scss/clearfix'  as *;

#criteria-bar {
  display: grid;
  grid-template-columns: auto;
  column-gap: 12px;
  row-gap: 10px;
  box-sizing: border-box;

  @include small-up {
    &.with-helpme {
      grid-template-columns: auto auto auto;
    }
    &.without-helpme {
      grid-template-columns: auto auto auto auto;
    }
  }

  @include medium-up {
    &.with-helpme {
      grid-template-columns: 15% auto auto 25% auto;
      justify-items: inherit;
    }
    &.without-helpme {
      grid-template-columns: 15% 40% 30% auto;
      justify-items: inherit;
    }
  }
}

#button-container {
  padding-top: 30px;
  button {
    height: 42px;
  }
}
</style>